import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import SearcherList from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import UsuariosInputCard from "./UsuariosInputCard";
import { getUsuarios } from "../actions";

export interface Usuarios {
  label: string | null;
  value: string | null;
}

interface ReduxState {
  altaPolizaMultiramaReducer: {
    usuariosFilter: Usuarios[];
    usuarioSelected: Usuarios;
    take: number;
  };
}

interface UsuariosSelectorProps {
  value: Usuarios;
  onChange?: (event: { target: { value: Usuarios } }) => void;
  onClear?: () => void;
  isLoading?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "grid",
    justifyContent: "space-between",
    padding: "2%",
    paddingTop: "3%",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridColumnGap: "0px",
    borderBottom: "1px solid #8B8B8B",
  },
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "260px",
    justifyContent: "space-around",
    justifySelf: "end",
    marginRight: "10px",
    position: "relative",
  },
  buttonLink: {
    display: "flex",
    alignItems: "center",
    color: "#f77221",
    paddingLeft: 8,
    cursor: "pointer",
  },
  caption: {
    justifyContent: "center",
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.38,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#8B8B8B",
  },
  listView: {
    position: "absolute",
    top: "85%",
    width: "260px",
    zIndex: 2 as any,
  },
}));

const useReduxSelector = () =>
  useSelector((state: ReduxState) => ({
    usuarios: state.altaPolizaMultiramaReducer.usuariosFilter,
    usuario: state.altaPolizaMultiramaReducer.usuarioSelected,
    take: state.altaPolizaMultiramaReducer.take,
  }));

function UsuariosSelector({
  value,
  onChange,
  onClear,
  isLoading,
}: UsuariosSelectorProps): JSX.Element {
  const [filter, setFilter] = useState<string>("");
  const [listView, setListView] = useState<boolean>(false);
  const dispatch = useDispatch();

  const { usuarios, usuario, take } = useReduxSelector();

  const handleUsuarioItem = (item: Usuarios) => {
    setFilter("");
    onChange?.({ target: { value: { label: item.label, value: item.value } } });
    setListView(false);
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const q = event.target.value;
    setFilter(q);
    if (q && q.length >= 2) {
      (dispatch as any)(getUsuarios(0, take, q));
    }
  };

  const classes = useStyles();

  type ListItem = { label: string; value: string | null };
  const baseList: Usuarios[] = usuarios;
  const listForView: ListItem[] = baseList.map((u) => ({
    label: u.label ?? "",
    value: u.value ?? null,
  }));

  return (
    <>
      {!value.label ? (
        <div
          className={classes.container}
          onClick={() => setListView((v) => !v)}
        >
          <Typography className={classes.caption}>{"Usuario"}</Typography>

          <div className={classes.searcher}>
            <SearcherList
              onClear={() => {
                setFilter("");
                setListView(false);
              }}
              filter={filter}
              onChange={handleFilterChange}
              placeholder={"Ingresá 2+ letras para buscar"}
            />
            {listView && (
              <div className={classes.listView}>
                <ListView
                  isLoading={isLoading}
                  onItemSelected={handleUsuarioItem}
                  list={listForView}
                  usePagination={false}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <UsuariosInputCard
            id={"usuarios"}
            isLoading={!!isLoading}
            label={"Usuario"}
            value={usuario.label ?? ""}
            variant="big"
            onClick={onClear}
          />
        </div>
      )}
    </>
  );
}

export default React.memo(UsuariosSelector);
